module.exports = __webpack_public_path__ + "static/img/play.0c61065.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/play.png
// module id = 4UnU
// module chunks = 1